import { render, staticRenderFns } from "./cityRightData.vue?vue&type=template&id=8391c324"
import script from "./cityRightData.vue?vue&type=script&lang=js"
export * from "./cityRightData.vue?vue&type=script&lang=js"
import style0 from "./cityRightData.vue?vue&type=style&index=0&id=8391c324&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports